<template>
  <div id="camera-play-back">
    <vs-row>
      <vs-col class="flex w-full justify-center items-center" >
        <play-back-player
          v-if="this.camera"
          :camera="camera"
          :componentType="'div'"
          ref="playBackPlayer"
          @reOpenDialog="reOpenDialog"
          @onChangeFullscreen="isFullscreen = $event"
        />
      </vs-col>
    </vs-row>

    <dialog-time-range-picker
      v-if="this.camera && this.camera.hash"
      ref="dialogTimeRangePicker"
      @showPlayBackPlayer="showPlayBackPlayer"
      @reOpenDialog="reOpenDialog"
    />
  </div>
</template>

<script>
import moment from "moment-timezone";
import { storageWebCam } from "@/firebase/firebaseConfig";
import DialogTimeRangePicker from "../../camera-list/components/DialogTimeRangePicker";
import _ from "lodash";
import PlayBackPlayer from "../../camera-list/components/PlayBackPlayer";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "enterpriseCameraList"
);


export default {
  components: {
    DialogTimeRangePicker,
    PlayBackPlayer,
  },
  data() {
    return {
      camera: null,
      cameraReady: false,
      pickerConfig: {
        playDate: null,
        playStartTime: null,
        enableDateList: null
      },
      isFullscreen: false,
    };
  },
  computed: {
    ...mapState({
      cameras: state => state.cameras
    }),
  },
  watch: {
    cameraReady() {
      if ( this.cameraReady ) {
        this.getExistVideoData();
        this.$nextTick(() => {
          this.recalcPlayerSize();
        });
      }
    }
  },
  methods: {
    ...mapActions(["hykeCamGetMedia", "fetchCameras"]),

    getExistVideoData() {
      if (!this.camera.hash) return;
      let enableDateList = [];
      storageWebCam
        .child(this.camera.hash)
        .listAll()
        .then(response => {
          if (response.prefixes.length == 0) {
            this.$vs.notify({
              color: "danger",
              title: "指定されたカメラの録画データがみつかりませんでした"
            });
          } else {
            _.forEach(response.prefixes, function(item) {
              enableDateList.push(
                moment(item.name)
                  .utc()
                  .tz("Asia/Tokyo")
                  .format("YYYY-MM-DD")
              );
            });
            this.pickerConfig.enableDateList = enableDateList;
            this.pickerConfig.playDate =
              enableDateList[enableDateList.length - 1];
            this.pickerConfig.playStartTime = null;
            this.$refs.dialogTimeRangePicker.show(this.pickerConfig);
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "カメラの録画データ取得に失敗しました"
          });
        });
    },

    async showPlayBackPlayer(payload) {
      this.recalcPlayerSize();
      this.pickerConfig = payload.pickerConfig;
      await this.recalcPlayerSize();
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.playBackPlayer.show(payload);
        }, 1000);
      });
    },

    reOpenDialog() {
      this.$refs.dialogTimeRangePicker.show(this.pickerConfig);
    },

    sleep(waitSec) {
      return new Promise(function (resolve) {
        setTimeout(function() { resolve() }, waitSec * 1000);
      });
    },

    async recalcPlayerSize() {

      let videoWidth = '500px';
      const videoPlayerAreaElement = document.getElementById('camera-play-back-area');
      if ( videoPlayerAreaElement ) {

        const itemPlayListEl = document.getElementById('item-play-list');
        const itemPlayListElWidth = itemPlayListEl ? itemPlayListEl.getBoundingClientRect().width : 248;
        
        const adjustedWidth = Math.min(
          ( videoPlayerAreaElement.getBoundingClientRect().width * 0.96 - itemPlayListElWidth ),
          ( videoPlayerAreaElement.getBoundingClientRect().height - 80 ) * 4 / 3  
        );
        videoWidth = adjustedWidth + 'px';

      }

      const playBackPlayerContainerEl = document.getElementById('play-back-player-container');
      if ( playBackPlayerContainerEl ) {
        playBackPlayerContainerEl.style['min-width'] = videoWidth; 
        playBackPlayerContainerEl.style['grid-template-rows'] = '1fr 80px'; 
        playBackPlayerContainerEl.style['grid-template-columns'] = videoWidth + ' 1fr';

        const scrollAreaEl = playBackPlayerContainerEl.getElementsByClassName('scroll-area');
        const scrollAreaHeight = videoPlayerAreaElement.getBoundingClientRect().height - 104;
        scrollAreaEl.forEach(el => {
          el.style['height'] =  Math.max( scrollAreaHeight , 300 ) + 'px';
        });

        const noVideosEl = playBackPlayerContainerEl.getElementsByClassName('no-video');
        noVideosEl.forEach(el => {
          el.style['min-width'] = videoWidth;
        });
      }

      const itemMainVideoEl = document.getElementById('item-main-video');
      if ( itemMainVideoEl ) {
        itemMainVideoEl.style['width'] = this.isFullscreen === true ? '100%' : videoWidth;
        const videosEl = itemMainVideoEl.getElementsByTagName('video');
        videosEl.forEach(el => {
          el.style['width'] = this.isFullscreen === true ? '100%' : videoWidth;
        });
      }

      let videoControlsEl = null;
      for ( let i = 0; i < 30; i++ ) {
        videoControlsEl = document.getElementById('video-controls');
        if ( videoControlsEl ) {
          break;
        }
        await this.sleep(0.3);
      }
      if ( videoControlsEl ) {
        videoControlsEl.style['width'] = this.isFullscreen === true ? '100%' : videoWidth; 
      }        
    },
  },
  async created() {
    await this.fetchCameras();
    this.camera = await this.cameras.find( x => x.id === this.$route.params.cameraId );
    this.cameraReady = true;

    const self = this;
    window.onresize = function () {
      for (let i=0; i<10; i++) {
        setTimeout(() =>{
          self.recalcPlayerSize();
        }, i * 800);
      }
    }
  },
};
</script>

